import { useAuth } from "@/context/AuthContext";
import StudentDashboard from "@/pages/StudentDashboard";
import InstructorDashboard from "@/pages/InstructorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "instructor") return <InstructorDashboard />;
  if (user.role === "admin") return <AdminDashboard />;
  return <StudentDashboard />;
}
